"use client"

import { format } from "date-fns"

export const parseBusySlotDate = (value?: string) => {
  if (!value) return null

  const localWallClock = value
    .replace(/([+-])(\d{1,2})$/, (_m, sign: string, hours: string) => `${sign}${hours.padStart(2, "0")}:00`)
    .replace(/(?:Z|[+-]\d{2}:\d{2})$/, "")

  const date = new Date(localWallClock)
  return Number.isNaN(date.getTime()) ? null : date
}

export const formatBusySlotTime = (value?: string) => {
  const date = parseBusySlotDate(value)
  return date ? format(date, "p") : (value ?? "Invalid time")
}
